import { Injectable } from '@angular/core';

import { AppinfoService, LbColumnType } from './appinfo.service';

export interface ColumnOperator {
	name: FilterOperatorName; // Name for db use
	symbol: string; // Symbol for displaying
	sq?: number;
	text?: string; // Name for displaying // Not using currently
}
export interface ColumnFilter {
	col: string; // column name
	typ: LbColumnType; // column type
	op: string; // operator
	val: any; // value
}
export interface Gfo {
	logic: string;
	filters: ColumnFilter[];
	src_tab?: string;
	ret_col?: string;
}

export type FilterOperatorName = 'eq' | 'lt' | 'lte' | 'gt' | 'gte' | 'ne' | 'in' | 'contains' | 'startswith' | 'between' | 'is null' | 'not null' | 'is empty' | 'not empty' | 'overlaps' | 'like' | 'not contains';
@Injectable()
export class GfoService {

	// public filterOperators: { [name: string]: FilterOperatorName } = {
	// 	contain: 'contains',
	// 	notContain: 'not contains',
	// 	startWith: 'startswith',
	// 	equal: 'eq',
	// 	between: 'between',
	// 	in: 'in',
	// 	lessThan: 'lt',
	// 	lessThanOrEqual: 'lte',
	// 	greaterThan: 'gt',
	// 	greaterThanOrEqual: 'gte',
	// 	overlap: 'overlaps',
	// 	like: 'like',
	// 	isNull: 'is null',
	// 	isEmpty: 'is empty',
	// 	notNull: 'not null',
	// 	notEmpty: 'not empty'
	// };
	public filterLogics = {
		and: 'and',
		or: 'or'
	};
	// public columnOperators: ColumnOperator[] = [
	// 	{text: 'equal', name: 'eq', symbol: '='},
	// 	{text: 'lessThan', name: 'lt', symbol: '<'},
	// 	{text: 'lessThanOrEqual', name: 'lte', symbol: '<='},
	// 	{text: 'greaterThan', name: 'gt', symbol: '>'},
	// 	{text: 'greaterThanOrEqual', name: 'gte', symbol: '>='},
	// 	{text: 'notEqual', name: 'ne', symbol: '<>'},
	// 	{text: 'in', name: 'in', symbol: 'In'},
	// 	{text: 'contain', name: 'contains', symbol: 'Contains'},
	// 	{text: 'startWith', name: 'startswith', symbol: 'Starts With'},
	// 	{text: 'between', name: 'between', symbol: 'Between'},
	// 	{text: 'is null', name: 'is null', symbol: 'isNull'},
	// 	{text: 'not null', name: 'not null', symbol: 'notNull'},
	// 	{text: 'is empty', name: 'is empty', symbol: 'isEmpty'},
	// 	{text: 'not empty', name: 'not empty', symbol: 'notEmpty'}

	// ];

	public tables: any = {};
	constructor(
		private appinfoService: AppinfoService
	) { }

	getFilter(column: string, operator: string, value: any, type?: LbColumnType): ColumnFilter {
		if (!type) {
			if (column.indexOf('.') !== -1) {
				type = this.appinfoService.columnMap[column.split('.')[0]].type;
			} else {
				type = this.appinfoService.columnMap[column] ? this.appinfoService.columnMap[column].type : 'text';
			}
		}
		return {
			col: column, // 'sub_cus_id',
			typ: type, // 'number',
			op: operator, // 'eq',
			val: value // 1027
		};
	}
	getReturnColumnsByNames(names: string[], table) {
		let returnColumns = '';
		for (const column of Object.keys(this.tables[table].columns)) {
			returnColumns += this.tables[table].columns[column] + ',';
		}
		// remove last comma;
		returnColumns = returnColumns.replace(/,\s*$/, '');
		return returnColumns;
	}
	getGfo(logic: string, filters: ColumnFilter[], tableName?: string, returnColumns?: string): Gfo {
		if (!filters || !filters.length) {
			return null;
		}
		return {
			logic: logic, // 'and',
			src_tab: tableName || null, // 'lba.v_subscriptions',
			ret_col: returnColumns || null, // null,
			filters: filters // array of filter
		};
	}
}
